import * as React from 'react';
import Svg, {
  SvgProps, Path, G, Line, Rect, Defs,
} from 'react-native-svg';

const ClearCloudyIcon = (props: SvgProps) => <Svg
  width="33" height="32" viewBox="0 0 33 32" fill="none" {...props}
>
  <Path fillRule="evenodd" clipRule="evenodd" d="M27.5 11.333C27.5 14.3706 25.0376 16.833 22 16.833C18.9624 16.833 16.5 14.3706 16.5 11.333C16.5 8.29544 18.9624 5.83301 22 5.83301C25.0376 5.83301 27.5 8.29544 27.5 11.333Z" stroke="#003A70" strokeWidth="1.5" />
  <G clipPath="url(#clip0_2079_86550)">
    <Line x1="31.25" y1="11.583" x2="29.75" y2="11.583" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip1_2079_86550)">
    <Line x1="14.25" y1="11.583" x2="12.75" y2="11.583" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip2_2079_86550)">
    <Line x1="29.8856" y1="16.1739" x2="28.5866" y2="15.4239" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip3_2079_86550)">
    <Line x1="26.4091" y1="19.4686" x2="25.6591" y2="18.1696" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip4_2079_86550)">
    <Line x1="17.9091" y1="4.74599" x2="17.1591" y2="3.44695" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip5_2079_86550)">
    <Line x1="21.75" y1="20.583" x2="21.75" y2="19.083" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip6_2079_86550)">
    <Line x1="21.75" y1="3.58301" x2="21.75" y2="2.08301" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip7_2079_86550)">
    <Line x1="17.1591" y1="19.2186" x2="17.9091" y2="17.9196" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip8_2079_86550)">
    <Line x1="25.6591" y1="4.49599" x2="26.4091" y2="3.19695" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip9_2079_86550)">
    <Line x1="13.8644" y1="15.7421" x2="15.1634" y2="14.9921" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <G clipPath="url(#clip10_2079_86550)">
    <Line x1="28.587" y1="7.24208" x2="29.8861" y2="6.49208" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </G>
  <Path d="M27 11.333C27 14.0944 24.7614 16.333 22 16.333C19.2386 16.333 17 14.0944 17 11.333C17 8.57158 19.2386 6.33301 22 6.33301C24.7614 6.33301 27 8.57158 27 11.333Z" fill="#F7C25D" />
  <Path fillRule="evenodd" clipRule="evenodd" d="M22.5444 14.043C22.5444 14.043 22.6673 14.667 22.7092 14.673C24.9717 14.9956 26.6693 16.3153 26.6693 18.667C26.6693 21.2443 24.5799 23.3337 22.0026 23.3337H10.0026C7.42527 23.3337 5.33594 21.2443 5.33594 18.667C5.33594 16.3153 7.07542 14.3699 9.33792 14.0473C9.37984 14.0413 9.42091 14.0401 9.46077 14.043C10.0619 10.9788 12.7623 8.66699 16.0026 8.66699C19.243 8.66699 21.9433 10.9788 22.5444 14.043Z" fill="#F7FAFD" />
  <Path d="M10.3555 23.3337C7.58329 23.3337 5.33594 21.1448 5.33594 18.4448C5.33594 16.0864 7.05049 14.1181 9.33179 13.6576C10.116 10.7842 12.8055 8.66699 16.0026 8.66699C19.6169 8.66699 22.5824 11.3728 22.88 14.8181C25.0205 15.1043 26.6693 16.8925 26.6693 19.0559C26.6693 21.4184 24.7028 23.3337 22.2771 23.3337H10.3555Z" stroke="#003A70" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  <Defs>
    <clipPath id="clip0_2079_86550">
      <Rect x="28.5" y="10.333" width="4" height="2" rx="1" fill="white" />
    </clipPath>
    <clipPath id="clip1_2079_86550">
      <Rect x="11.5" y="10.333" width="4" height="2" rx="1" fill="white" />
    </clipPath>
    <clipPath id="clip2_2079_86550">
      <Rect x="28.1289" y="13.7168" width="4" height="2" rx="1" transform="rotate(30 28.1289 13.7168)" fill="white" />
    </clipPath>
    <clipPath id="clip3_2079_86550">
      <Rect x="26.1172" y="16.4619" width="4" height="2" rx="1" transform="rotate(60 26.1172 16.4619)" fill="white" />
    </clipPath>
    <clipPath id="clip4_2079_86550">
      <Rect x="17.6172" y="1.73926" width="4" height="2" rx="1" transform="rotate(60 17.6172 1.73926)" fill="white" />
    </clipPath>
    <clipPath id="clip5_2079_86550">
      <Rect x="23" y="17.833" width="4" height="2" rx="1" transform="rotate(90 23 17.833)" fill="white" />
    </clipPath>
    <clipPath id="clip6_2079_86550">
      <Rect x="23" y="0.833008" width="4" height="2" rx="1" transform="rotate(90 23 0.833008)" fill="white" />
    </clipPath>
    <clipPath id="clip7_2079_86550">
      <Rect x="19.6172" y="17.4619" width="4" height="2" rx="1" transform="rotate(120 19.6172 17.4619)" fill="white" />
    </clipPath>
    <clipPath id="clip8_2079_86550">
      <Rect x="28.1172" y="2.73926" width="4" height="2" rx="1" transform="rotate(120 28.1172 2.73926)" fill="white" />
    </clipPath>
    <clipPath id="clip9_2079_86550">
      <Rect x="16.8711" y="15.4492" width="4" height="2" rx="1" transform="rotate(150 16.8711 15.4492)" fill="white" />
    </clipPath>
    <clipPath id="clip10_2079_86550">
      <Rect x="31.5938" y="6.94922" width="4" height="2" rx="1" transform="rotate(150 31.5938 6.94922)" fill="white" />
    </clipPath>
  </Defs>
</Svg>;

export default ClearCloudyIcon;
